"use client";

import * as React from "react";

import { CompanyEntity } from "./CompanyEntity";
import type { CompanyEntityProps } from "./CompanyEntity.types";

/**
 * Board preset — row layout with expand + research. Used by the
 * Board companies view (CompanyReportView table mode) and any other
 * expandable "company → contacts" list.
 */
const CompanyBoard: React.FC<CompanyEntityProps> = (props) => (
  <CompanyEntity
    layout="row"
    actions={{ expand: true, research: true, ...props.actions }}
    {...props}
  />
);
CompanyBoard.displayName = "CompanyEntity.Board";

/**
 * Search preset — card layout with quick-view + research. Used by
 * company search results (`/dashboard/companies/search`) and the
 * Companies hub (`/companies`).
 */
const CompanySearch: React.FC<CompanyEntityProps> = (props) => (
  <CompanyEntity
    layout="card"
    actions={{ quickView: true, research: true, ...props.actions }}
    {...props}
  />
);
CompanySearch.displayName = "CompanyEntity.Search";

/**
 * Radar preset — dense company-row list. Compact density, research
 * action only. Ships without a Phase-1 call site.
 */
const CompanyRadar: React.FC<CompanyEntityProps> = (props) => (
  <CompanyEntity
    layout="row"
    density="compact"
    actions={{ research: true, ...props.actions }}
    {...props}
  />
);
CompanyRadar.displayName = "CompanyEntity.Radar";

CompanyEntity.Board = CompanyBoard;
CompanyEntity.Search = CompanySearch;
CompanyEntity.Radar = CompanyRadar;

export { CompanyBoard, CompanySearch, CompanyRadar };
